
import { Component, Input, EventEmitter, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionType } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';

import { IChoiceAction, IConfirmModalContent } from '../../models';

// TODO: Migrate first

@Component({
	selector: 'choices-modal',
	templateUrl: './choices-modal.component.html',
	imports: [TranslateModule]
})
export class ChoicesModalComponent {
	activeModal = inject(NgbActiveModal);


	@Input() contentConfig: IConfirmModalContent;
	@Input() choices: IChoiceAction[];
	@Output() output = new EventEmitter<IChoiceAction>();

	actionTypes = ActionType;
}
